module.exports = __webpack_public_path__ + "img/99_exercises_splash.c5960147.jpg";